var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preloader"},[_c('div',{staticClass:"loader"},[_c('div',{staticClass:"father"},[_c('div',{staticClass:"one"})]),_c('div',{staticClass:"two"}),_c('div',{staticClass:"three"}),_c('div',{staticClass:"mother"},[_c('div',{staticClass:"num-for"})])])])
}]

export { render, staticRenderFns }